const checkboxHandler = (formik, e) =>
  formik.setFieldValue([e.target.name], e.target.checked);

export default checkboxHandler;
